import { render, staticRenderFns } from "./FirebaseSetting.vue?vue&type=template&id=65ae1b75&scoped=true"
import script from "./FirebaseSetting.vue?vue&type=script&lang=js"
export * from "./FirebaseSetting.vue?vue&type=script&lang=js"
import style0 from "./FirebaseSetting.vue?vue&type=style&index=0&id=65ae1b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae1b75",
  null
  
)

export default component.exports